"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CastList = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const list_item_styles_1 = require("@/components/common/list-item/list-item.styles");
const shared_styles_1 = require("@/stylesheets/shared.styles");
require("@/components/common");
/**
 * 작품에 참여한 인물과 그 인물의 상세로 가는 링크를 묶어 보여주는 목록.
 * 행이 눌리지만 명령이 아니라 탐색이므로 menu가 아닌 list로 읽히고, 각 링크가 저마다 Tab 순서를 갖는다.
 */
let CastList = class CastList extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.casts = [];
    }
    render() {
        return (0, lit_1.html) `
      <mm-list-item-group>${this.casts.map(cast => this.renderCast(cast))}</mm-list-item-group>
    `;
    }
    renderCast(cast) {
        return (0, lit_1.html) `
      <div>
        <a href=${cast.href}>
          <mm-list-item
            size="large"
            label=${cast.name}
            description=${cast.credit}
            avatar-src=${cast.imageSrc ?? ''}
            avatar-shape="circle"
          ></mm-list-item>
        </a>
      </div>
    `;
    }
};
CastList.styles = [
    shared_styles_1.resetStyles,
    list_item_styles_1.interactiveRowStyles,
    (0, lit_1.css) `
      :host {
        display: block;
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], CastList.prototype, "casts", void 0);
CastList = __decorate([
    (0, decorators_js_1.customElement)('mm-cast-list')
], CastList);
exports.CastList = CastList;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FzdC1saXN0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY2FzdC1saXN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBMkQ7QUFFM0QscUZBQXFGO0FBQ3JGLCtEQUF5RDtBQUN6RCwrQkFBNEI7QUFVNUI7OztHQUdHO0FBRUksSUFBTSxRQUFRLEdBQWQsTUFBTSxRQUFTLFNBQVEsZ0JBQVU7SUFBakM7O1FBVTJCLFVBQUssR0FBaUIsRUFBRSxDQUFBO0lBdUIxRCxDQUFDO0lBckJDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzRCQUNhLElBQUksQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsQ0FBQztLQUNwRSxDQUFBO0lBQ0gsQ0FBQztJQUVPLFVBQVUsQ0FBQyxJQUFnQjtRQUNqQyxPQUFPLElBQUEsVUFBSSxFQUFBOztrQkFFRyxJQUFJLENBQUMsSUFBSTs7O29CQUdQLElBQUksQ0FBQyxJQUFJOzBCQUNILElBQUksQ0FBQyxNQUFNO3lCQUNaLElBQUksQ0FBQyxRQUFRLElBQUksRUFBRTs7Ozs7S0FLdkMsQ0FBQTtJQUNILENBQUM7O0FBL0JNLGVBQU0sR0FBRztJQUNkLDJCQUFXO0lBQ1gsdUNBQW9CO0lBQ3BCLElBQUEsU0FBRyxFQUFBOzs7O0tBSUY7Q0FDRixDQUFBO0FBQytCO0lBQS9CLElBQUEsd0JBQVEsRUFBQyxFQUFFLFNBQVMsRUFBRSxLQUFLLEVBQUUsQ0FBQzt1Q0FBeUI7QUFWN0MsUUFBUTtJQURwQixJQUFBLDZCQUFhLEVBQUMsY0FBYyxDQUFDO0dBQ2pCLFFBQVEsQ0FpQ3BCO0FBakNZLDRCQUFRIn0=